import * as Helpers from './helpers';
Avatar.theme = Avatar.theme || {};

Avatar.theme.Base = function Base() {
  var selectors = {
    spinner: '.spinner'
  };

  function init() {
    initSpinner();
    Helpers.focusFormStatus();
    Helpers.swapImagePlaceholder();
    Helpers.onLoadHideImagePlaceholder();
  }

  function initSpinner() {
    var state = document.readyState;
    var spinner = document.querySelector(selectors.spinner);

    if (state === 'interactive') {
      spinner.classList.add('hidden');

      spinner.ontransitionend = function () {
        spinner.classList.add('loaded');
      };
    }
  }

  init();
  return {
    init: init
  };
}();